//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    name: 'about',
    data () {
      return {
        top: 0
      }
    },
    methods: {
      onClickLeft () {
        this.$router.goBack()
      },
      goInfo () {
        this.$router.push({
          path: '/user-info'
        })
      }
    },
    created () {
      if (this.$global.isApp) {
        this.top = api.safeArea.top
      }
    }
  }
  


// WEBPACK FOOTER //
// ./src/pages/Home/about.vue